import { useCallback, useState } from "react";

import { Organization } from "../../../../dtos/organization";
import { AjaxResult } from "../../../../enums/ajaxResult";
import { useApi } from "../../../useApi";

export function useOrganizationLoad(organizationId: number | undefined) {
    const [organization, setOrganization] = useState<Organization>();
    const [loading, setLoading] = useState(false);
    const { orgApi } = useApi();

    const loadOrganization = useCallback(() => {
        if (!organizationId) {
            return;
        }
        setLoading(true);
        orgApi.getById(organizationId).then((r) => {
            if (r.result === AjaxResult.Success && r.data) {
                setOrganization(r.data);
            }
            setLoading(false);
        });
    }, [orgApi, organizationId]);

    return {
        loadOrganization,
        organization,
        loading,
    };
}